import { Modal } from 'components';
import {
  Badge,
  Button,
  Heading,
  List,
  ListItem,
  Text,
} from 'components/chroma';
import React, { useEffect, useState } from 'react';
import Media from 'react-media';
import { SCREEN } from 'scenes/common/types/screen';
import { useIntersitialContext } from 'scenes/motor/context';
import styled from 'styled-components';
import { COLOURS } from 'theme';

const BadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: -12px;

  .c-badge--primary {
    background-color: ${COLOURS.WHITE} !important;
    color: ${COLOURS.RED} !important;
    border: 2px solid;
  }
`;

const ModalContentWrapper = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;

  .c-list {
    border-left: 2px solid #f0f0f0;
    position: relative;
    display: flex;
    flex-flow: column;
    gap: 1.5rem;
    margin-left: 1rem;
  }

  .c-list__item {
    margin: 0 !important;
  }

  .c-text {
    padding-left: 1rem;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 1.75rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const getHeader = (isPreQuote: boolean) =>
  isPreQuote
    ? `You're minutes away from your quote! We have a few quick questions
first`
    : `You're almost done!`;

const getFlows = (isPreQuote: boolean) =>
  isPreQuote
    ? [
        {
          flowNumber: 1,
          flowName: 'Car Details',
        },
        {
          flowNumber: 2,
          flowName: 'Driver Details',
        },
        {
          flowNumber: 3,
          flowName: 'Car Usage',
        },
        {
          flowNumber: 4,
          flowName: 'Other Details',
        },
        {
          flowNumber: 5,
          flowName: 'Quote',
        },
      ]
    : [
        {
          flowNumber: 6,
          flowName: 'Customise',
        },
        {
          flowNumber: 7,
          flowName: 'Policy Details',
        },
        {
          flowNumber: 8,
          flowName: 'Payment',
        },
      ];

export const InterstitialModal = ({ preQuote }: { preQuote: boolean }) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const [value, updater] = useIntersitialContext();
  const headerText = getHeader(preQuote);
  const flows = getFlows(preQuote);

  useEffect(() => {
    const id = setTimeout(() => {
      setIsOpen(false);
      if (preQuote) {
        updater({ ...value, preQuote: false });
        return;
      }
      updater({ ...value, postQuote: false });
    }, 5000);
    return () => clearTimeout(id);
  }, [preQuote, updater, value]);

  return (
    <>
      <Media query={{ maxWidth: SCREEN.MEDIUM }}>
        <Modal
          isOpen={isOpen}
          onClose={() => {
            setIsOpen(false);
          }}
          styles={{ width: '369px' }}
        >
          <ModalContentWrapper>
            <Heading size={4} margin={{ top: 6 }} textAlign="center">
              {headerText}
            </Heading>
            <List>
              {flows.map((flow) => (
                <ListItem
                  keyProp={flow.flowNumber}
                  margin={{
                    bottom: 2,
                  }}
                  alignItems="center"
                >
                  <BadgeWrapper>
                    <Badge numbered primary>
                      {flow.flowNumber}
                    </Badge>
                  </BadgeWrapper>
                  <Text>{flow.flowName}</Text>
                </ListItem>
              ))}
            </List>
            <ButtonWrapper>
              <Button primary onClick={() => setIsOpen(false)}>
                Continue
              </Button>
            </ButtonWrapper>
          </ModalContentWrapper>
        </Modal>
      </Media>
    </>
  );
};
